import { render, staticRenderFns } from "./StockMetas.vue?vue&type=template&id=bfa0c17e&scoped=true&"
import script from "./StockMetas.vue?vue&type=script&lang=js&"
export * from "./StockMetas.vue?vue&type=script&lang=js&"
import style0 from "./StockMetas.vue?vue&type=style&index=0&id=bfa0c17e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa0c17e",
  null
  
)

export default component.exports